import vueAppInitiator from '../../modules/vue-app-initiator';
import Creditors from '../../vue-components/pages/mortgage-standard/Creditors';

document.addEventListener('DOMContentLoaded', () => {
    const vueApps = [
        {
            el: '#js--creditors',
            components: { Creditors }
        }
    ];
    vueAppInitiator(vueApps);
});
